import { useToast as useRNToast } from 'react-native-toast-notifications';
import { useTheme } from '@ui-kitten/components';

import Toast from '../Components/Toast';
import constants from '../Config/constants';

const { isWeb, SUCCESS_CONFIG, ERROR_CONFIG } = constants;

function useToast() {
  const toast = useRNToast();
  const theme = useTheme();

  const _hide = (toastId) => {
    if (isWeb) {
      if (toastId) {
        // if has toastId, hide specific toast
        toast.hide(toastId);
      } else {
        // if no toastId, hide all toast
        toast.hideAll();
      }
    } else {
      // no hide toast in mobile, toast in mobile is not stacking
    }
  };

  const _show = (data, isSuccess = true, type) => {
    if (isWeb) {
      const conf = isSuccess ? SUCCESS_CONFIG : ERROR_CONFIG;
      toast.show(data, {
        ...conf,
        type: type || conf.type,
        ...(theme?.icon_color && {
          style: {
            backgroundColor: theme?.icon_color,
          },
        }),
      });
    } else {
      Toast.show(
        data,
        type || (isSuccess ? Toast.TYPE_SUCCESS : Toast.TYPE_ERROR),
      );
    }
  };

  return {
    hide: _hide,
    show: _show,
  };
}

export default useToast;
